import React, { useEffect, useState } from "react";
import { Menu, X, Phone, Mail } from "lucide-react";
import { Button } from "./ui/button";
import { NAV_LINKS, COMPANY } from "../mock";
import { cn } from "../lib/utils";
import { LogoWordmark } from "./Logo";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top utility bar */}
      <div className="hidden md:block bg-slate-900 text-slate-200 text-xs">
        <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-yellow-600" /> {COMPANY.phone}</span>
            <span className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-yellow-600" /> {COMPANY.email}</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-slate-400">{COMPANY.hours}</span>
            <span className="h-3 w-px bg-slate-700" />
            <span className="text-yellow-500 font-semibold tracking-wide">HUNTER DOUGLAS AUTHORISED PARTNER</span>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <header
        id="home"
        className={cn(
          "sticky top-0 z-50 w-full transition-colors duration-300",
          scrolled ? "bg-white/95 backdrop-blur border-b border-slate-200 shadow-sm" : "bg-white border-b border-slate-100"
        )}
      >
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <a href="#home" className="flex items-center gap-3 group">
            <LogoWordmark height={40} />
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="px-4 py-2 text-sm font-semibold text-slate-700 hover:text-yellow-700 relative group"
              >
                {l.label}
                <span className="absolute left-4 right-4 -bottom-1 h-0.5 bg-yellow-600 scale-x-0 group-hover:scale-x-100 origin-left transition-transform" />
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a href="#contact">
              <Button className="bg-yellow-700 hover:bg-yellow-800 text-white font-semibold btn-shine">
                Get a Quote
              </Button>
            </a>
          </div>

          <button
            className="lg:hidden p-2 text-slate-900"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-slate-200 bg-white">
            <div className="px-6 py-4 flex flex-col gap-1">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="py-2.5 text-base font-semibold text-slate-800 hover:text-yellow-700 border-b border-slate-100"
                >
                  {l.label}
                </a>
              ))}
              <a href="#contact" onClick={() => setOpen(false)} className="mt-3">
                <Button className="w-full bg-yellow-700 hover:bg-yellow-800 text-white font-semibold">Get a Quote</Button>
              </a>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
